<app-page-header header="agent-success.title" />

<qbe-panel-component class="success">
  <div class="page-container">
    <div class="success-container">
      <div class="success-summary">
        <h2 nxHeadline="section" class="success-headline">
          {{ 'agent-success.header' | translate : (summaryParams$ | async) }}
        </h2>
        <p nxCopytext="normal" class="success-copy" [innerHTML]="'agent-success.summary' | translate"></p>
        <a [href]="policyPdf$ | async" target="_blank" nxButton="primary">
          <nx-icon class="nx-margin-right-2xs" name="download" nxIconPositionStart></nx-icon>{{ 'agent-success.cta' | translate }}
        </a>
      </div>

      <section class="success-offer">
        <figure class="success-illustration">
          <qbe-illustration name="clientAndAgentShakingHands"></qbe-illustration>
        </figure>
      </section>
    </div>
  </div>
</qbe-panel-component>
